import React from 'react';
import { Link } from 'react-router-dom';
import { getPluralSuffix } from '../../../../utils/plurals';
import moment from 'moment';

/**
 * @typedef {object} TasksDueNotificationCardProps
 * @property {string} [label]
 * @property {string} [redirectUrl]
 * @property {string} [dueDate]
 */

/**
 * @param {TasksDueNotificationCardProps} props
 */
const TasksDueNotificationCard = props => {
  const { label, redirectUrl, dueDate } = props;

  const dueDateText = getDueDateText(dueDate);

  return (
    <div className='notification-card'>
      <div className='notification-card__title'>
        <Link to={redirectUrl} className='notification__link'>
          {label}
        </Link>
      </div>
      <div className='notification-card__date'>{dueDateText}</div>
    </div>
  );
};

const getDueDateText = dueDate => {
  const dueDays = moment(dueDate).startOf('day').diff(moment().startOf('day'), 'days');

  if (dueDays > 0) {
    return `Due in ${dueDays} day${getPluralSuffix(dueDays)}`;
  }

  if (dueDays === 0) {
    return 'Due today';
  }

  return `Past due ${Math.abs(dueDays)} day${getPluralSuffix(Math.abs(dueDays))}`;
};

export default TasksDueNotificationCard;
